import { combineReducers } from 'redux';

import auth from './auth/reducer';
import user from './user/reducer';
import lab from './lab/reducer';
import equipment from './equipment/reducer';

const reducers = combineReducers({
  auth,
  user,
  lab,
  equipment,
});

export default reducers;
